import styles from "./style.module.css";
import SuccessIcon from "../../assets/icons/SuccessIcon";
import CopyIcon from "../../assets/icons/CopyIcon";
import { useNavigate } from "react-router";
import { copyText } from "../../utils/helpers";
import apiHooks from "../../customHooks/apis";
import LoadingSpinner from "../LoadingSpinner";
import { removeLocalStorageItem } from "../../utils/localStorage";
const SuccessDialog = () => {
  const { useUpdateCampaignDetails } = apiHooks;
  const { loading, accountNumber } = useUpdateCampaignDetails();
  const navigate = useNavigate();

  const currency = localStorage.getItem("currency") || "";

  const handleClickOkay = () => {
    if (currency) removeLocalStorageItem("currency");
    navigate("/");
  };

  if (loading) return <LoadingSpinner />;
  return (
    <div className={styles.successDialogWrapper}>
      <SuccessIcon />
      <div className="d-flex flex-column">
        <span className={styles.welcomeText}>Welcome to AltBank</span>
        <span className={styles.welcomeText}>Your Account is Ready!</span>
      </div>
      <div className={styles.accNoDisplay}>
        {!!currency && <span className={styles.currency}>{currency}</span>}
        <span className={styles.accountNumber}>{accountNumber}</span>
        <button
          className={styles.copyBtn}
          onClick={() => copyText(accountNumber)}
        >
          <CopyIcon />
        </button>
      </div>
      <p className={styles.message}>
        Congratulations! Your AltBank account has been successfully created. 🎉
        <br />
        You’re now part of a community that’s redefining banking. Here’s what’s
        next: <br /> Start managing your money anytime, anywhere. <br /> Enjoy
        seamless transactions and exclusive benefits.
      </p>
      <button onClick={handleClickOkay} className={styles.okayBtn}>
        Okay
      </button>
    </div>
  );
};

export default SuccessDialog;
